export default __webpack_public_path__ + "static/media/4.05ac3872.png";